import API from 'services/api';

import { IRatePlan } from '../models';

interface IUpsertRatePlan {
  id?: string;
  payload: IRatePlan;
}

export const upsertRatePlan = ({ id, payload }: IUpsertRatePlan) => {
  if (!!id) {
    return API.put(`/api/accommodation/rate-plan/${id}`, payload);
  } else {
    return API.post('/api/accommodation/rate-plan', payload);
  }
};
